import { render, staticRenderFns } from "./SidebarDefaultNavigationFooter.vue?vue&type=template&id=51fd6588&scoped=true&"
import script from "./SidebarDefaultNavigationFooter.vue?vue&type=script&lang=js&"
export * from "./SidebarDefaultNavigationFooter.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDefaultNavigationFooter.vue?vue&type=style&index=0&id=51fd6588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fd6588",
  null
  
)

export default component.exports